import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgSunGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M24 14.74c-.41 0-.75-.34-.75-.75V8.75c0-.41.34-.75.75-.75s.75.34.75.75v5.24c0 .42-.34.75-.75.75ZM24.02 31.11c-3.92 0-7.11-3.19-7.11-7.11 0-3.92 3.19-7.11 7.11-7.11 3.92 0 7.11 3.19 7.11 7.11 0 3.92-3.19 7.11-7.11 7.11Zm0-12.72A5.62 5.62 0 0 0 18.41 24a5.62 5.62 0 0 0 5.61 5.61A5.62 5.62 0 0 0 29.63 24a5.62 5.62 0 0 0-5.61-5.61ZM24 40c-.41 0-.75-.34-.75-.75v-5.24c0-.41.34-.75.75-.75s.75.34.75.75v5.24c0 .41-.34.75-.75.75ZM16.95 17.7c-.19 0-.38-.07-.53-.22l-3.73-3.73a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l3.73 3.74c.29.29.29.77 0 1.06-.15.14-.34.21-.53.21ZM34.78 35.53c-.19 0-.38-.07-.53-.22l-3.68-3.68a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l3.68 3.68c.29.29.29.77 0 1.06a.71.71 0 0 1-.53.22ZM31.17 17.58c-.19 0-.38-.07-.53-.22a.754.754 0 0 1 0-1.06l3.62-3.62c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-3.62 3.62c-.15.15-.34.22-.53.22ZM13.22 35.53c-.19 0-.38-.07-.53-.22a.754.754 0 0 1 0-1.06l3.8-3.8c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-3.8 3.8c-.15.15-.34.22-.53.22ZM14.06 24.75H8.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5.31a.749.749 0 1 1 0 1.5ZM39.25 24.75h-5.2c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5.2c.41 0 .75.34.75.75s-.34.75-.75.75Z",
    fill: "currentColor"
  }));
}

export { SvgSunGlyphSecondary as default };
